import { countryGetIsoCode } from "@studyportals/static-domain-data/countries/country-get-iso-code";
import { countryGetIdFromIsoCode } from "@studyportals/static-domain-data/countries/country-get-id-from-iso-code";

type CountryIdentifierMapResult = { identifiers: string[]; hasChanged: boolean };

const isNumericIdentifier = (value: string): boolean => {
	return value.trim() !== "" && !Number.isNaN(Number(value));
};

export const mapCountryIdentifiersToIso = (identifiers: string[]): CountryIdentifierMapResult => {
	let hasChanged = false;

	const mapped = identifiers.map((identifier) => {
		if (!isNumericIdentifier(identifier)) return identifier;

		const iso = countryGetIsoCode(identifier);
		if (!iso) return identifier;

		hasChanged = true;
		return iso;
	});

	return { identifiers: mapped, hasChanged };
};

export const mapCountryIdentifiersToIds = (identifiers: string[]): CountryIdentifierMapResult => {
	let hasChanged = false;

	const mapped = identifiers.map((identifier) => {
		if (isNumericIdentifier(identifier)) return identifier;

		const id = countryGetIdFromIsoCode(identifier);
		if (!id) return identifier;

		hasChanged = true;
		return id;
	});

	return { identifiers: mapped, hasChanged };
};
